export const baseURL = process.env.REACT_APP_BASE_URL || "/";
export const adminBaseURL = process.env.REACT_APP_ADMIN_BASE_URL || "";
export const key = "";